import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { href: "/#metodo", label: "Metodo" },
  { href: "/#chi-sono", label: "Chi Sono" },
  { href: "/#pacchetti", label: "Pacchetti" },
  { href: "/#faq", label: "FAQ" },
  { href: "/contatti", label: "Contatti" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const goTo = (href) => {
    setOpen(false);
    if (href.startsWith("/#")) {
      const id = href.slice(2);
      if (window.location.pathname !== "/") {
        navigate("/");
        setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 150);
      } else {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate(href);
      window.scrollTo(0, 0);
    }
  };

  return (
    <nav data-testid="main-nav" className="sticky top-0 z-40 bg-[#0d0718]/90 backdrop-blur-md border-b border-[#2d1b4e] px-6 py-4">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" aria-label="MP Coaching home">
          <Logo />
        </Link>
        <div className="hidden md:flex items-center gap-8 text-sm text-[#cbd5e1]">
          {LINKS.map((l) => (
            <button key={l.href} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => goTo(l.href)} className="hover:text-white transition-colors">
              {l.label}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <button data-testid="nav-cta-pacchetti" onClick={() => goTo("/#pacchetti")}
            className="px-5 py-2.5 rounded-lg bg-gradient-to-r from-[#6a0dad] to-[#a020f0] text-white text-xs font-bold uppercase tracking-wider hover:brightness-110 shadow-lg shadow-[#6a0dad]/40 transition-[filter,transform]">
            Scegli Pacchetto
          </button>
          <button data-testid="nav-mobile-toggle" className="md:hidden text-white" onClick={() => setOpen(!open)} aria-label="Menu">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>
      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden mt-4 pb-2 flex flex-col gap-4 text-sm text-[#cbd5e1]">
          {LINKS.map((l) => (
            <button key={l.href} data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => goTo(l.href)} className="text-left hover:text-white transition-colors">
              {l.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
};
